module.exports = __webpack_public_path__ + "img/53.3b5367c2.jpg";